import React, { FC } from 'react';
import { Alignment, HeadingOption, NumbersItem } from '../../types';
import { EditorialHeadline } from './EditorialHeadline';
import { Numbers } from './EditorialNumbers';

export interface NumbersModeProps {
  components: NumbersItem[][];
  headingOption?: HeadingOption;
  alignmentNumbers: Alignment;
  flexibleWidth?: boolean;
  ctaComponentList?: NumbersItem[];
}

export const NumbersMode: FC<NumbersModeProps> = ({
  components,
  headingOption,
  alignmentNumbers,
  flexibleWidth,
  ctaComponentList,
}) => {
  return (
    <>
      <EditorialHeadline
        headingOption={headingOption}
        testid="numbers-headline-container"
        alignment={alignmentNumbers}
      />
      <Numbers
        components={components}
        alignmentNumbers={alignmentNumbers}
        flexibleWidth={flexibleWidth}
        ctaComponentList={ctaComponentList}
      />
    </>
  );
};
